import { formatNumber } from 'src/utils/numberFormatter';
import { formatPriceTextOnly } from 'src/utils/priceFormatter';

const useReportingCalculations = () => {
  // const getPieChartDataset = useCallback((data: any, arrayName?: string) => { // popularCabinClasses
  //   // const t = type?.toUpperCase();
  //   const column_order = ['ECONOMY', 'PREMIUM_ECONOMY', 'BUSINESS', 'FIRST', 'MIXED'];

  //   switch (arrayName) {
  //     case 'popularCabinClasses':
  //       if (!data?.content?.length) return []; // pop...
  //       const result = mapper(data.content, 'cabinClass'); // pop...
  //       const sortedArray = reorderArray(column_order, result);

  //       return sortedArray;
  //     case ProgrammeType.JOURNEY:
  //       if (!mock?.transportMode?.content?.length) return [];

  //       return mapper(mock.transportMode.content, 'mode');
  //     default:
  //       return [];
  //   }
  // }, []);

  const formattedPrice = (price: any) => {
    return formatPriceTextOnly(
      { currency: price?.currency, value: price?.value, zeroDecimalCurrency: true },
      true
    );
  };

  const getSummaryDataByProgramme = (stats: any, type?: string) => {
    switch (type) {
      case 'FLIGHT_DATA_SUMMARY':
        const price = stats?.averagePrice;
        return {
          totalOffsets: stats?.totalOffsets,
          title: formatNumber(stats?.totalOffsets),
          subtitle: 'Number of offset transactions',
          rows: [
            { title: `${stats?.totalPassengers}`, subtitle: 'Number of passengers' },
            { title: `${price && formattedPrice(price)}`, subtitle: 'Average price' },
          ],
        };
      case 'JOURNEY_DATA_SUMMARY':
        const distance = stats?.totalDistance;
        return {
          totalOffsets: stats?.totalJourneys,
          title: formatNumber(stats?.totalJourneys),
          subtitle: 'Number of journeys offset',
          rows: [
            { title: `${stats?.totalStages}`, subtitle: 'Number of stages' },
            { title: `${distance && formatNumber(distance?.value)} ${distance?.unit?.toLowerCase()}`, subtitle: 'Total journey distance' },
          ],
        };
      case 'LOW_CARBON_TRAVEL': 
      const low = (stats?.totalPublicTransportOnlyJourneys + stats?.totalElectricVehiclesOnlyJourneys) / stats?.totalJourneys * 100;
      const publicJourneys = (stats?.totalPublicTransportOnlyJourneys / stats?.totalJourneys) * 100;
      const evsJourneys = (stats?.totalElectricVehiclesOnlyJourneys / stats?.totalJourneys) * 100;
        return {
          totalOffsets: stats?.totalJourneys,
          title: formatNumber(low),
          subtitle: '% Low carbon',
          rows: [
            { title: formatNumber(publicJourneys), subtitle: '% Public transport journeys' },
            { title: formatNumber(evsJourneys), subtitle: '% Electric vehicle journeys' },
          ],
        }
      default:
        return null;
    }
  };

  return {
    getSummaryDataByProgramme,
  };
};

export default useReportingCalculations;